// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import axios from "axios";
import { setSession } from "../utils/sessionstore";
import { encryptHeader } from "../utils/encryptHeader";
const API_ENDPOINT = require("../config/server");
const { getSession } = require("../utils/sessionstore");


// In-memory cache so reopening the same guide within the session is instant
// instead of re-fetching the whole chapters/sections/contents payload again.
const helpDocCache = new Map();

export async function getHelpDocPopUpById(id, { skipCache = false } = {}) {
  if (!skipCache && helpDocCache.has(id)) {
    return helpDocCache.get(id);
  }

  const response = await fetchHelpDocPopUpById(id);
  helpDocCache.set(id, response);
  return response;
}

async function fetchHelpDocPopUpById(id) {
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "GET_HELP_POPUP",
      Method: "GET",
    },

    Parameters: {
      id: id,
    },
  };
  
  const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id"),
      Authorization: `Bearer ${encryptedHeader}`,
      "IV":iv,
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
    withCrendentials: true,
  };
  const response = await axios(axiosoptions);

  return response.data;
}
